import { useEffect } from "react";
import { Card, Form, Input, Button, Spin, Alert } from "antd";
import { LoginOutlined, UserOutlined, LockOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import store from "store";
import { unwrapResult } from "@reduxjs/toolkit";

import Background from "./background";
import { loginAction, selectLogin } from "./loginSlice";
import { selectMain } from "Main/mainSlice";
import { redirectUrl } from "utils";

export default function Login() {
  const _login = useSelector(selectLogin);
  const history = useHistory();
  const main = useSelector(selectMain);
  const dispatch = useDispatch();

  useEffect(() => {
    const auth = store.get("auth");
    if (auth) {
      const { locationPathname, locationQuery } = main;
      const redirect = redirectUrl(locationPathname, locationQuery);
      history.push({
        pathname: redirect[0],
        search: redirect[1],
      });
    }
  }, [history, main]);

  const onFinish = async (values) => {
    const res = await dispatch(loginAction(values));
    const result = unwrapResult(res);
    store.set("auth", result);

    const { locationPathname, locationQuery } = main;
    const redirect = redirectUrl(locationPathname, locationQuery);
    history.push(decodeURIComponent(redirect.join("")));
  };

  return (
    <>
      <Background />
      <div
        style={{
          width: 400,
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "1px 1px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Spin spinning={_login.loading}>
          <Card bordered={false}>
            {_login.error && (
              <Alert
                type="error"
                message={_login.error}
                style={{ marginBottom: "10px" }}
                showIcon
              />
            )}
            <Form size="middle" layout="vertical" onFinish={onFinish}>
              <Form.Item
                label="Tên đăng nhập"
                name="email"
                rules={[{ required: true, message: "Không được để trống" }]}
                hasFeedback
              >
                <Input placeholder="Nhập tên" prefix={<UserOutlined />} />
              </Form.Item>
              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[{ required: true, message: "Không được để trống" }]}
                hasFeedback
              >
                <Input.Password
                  placeholder="Nhập mật khẩu"
                  prefix={<LockOutlined />}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  block
                  icon={<LoginOutlined />}
                  htmlType="submit"
                  loading={_login.loading}
                  // onClick={() => history.replace("/match-manager")}
                >
                  Đăng nhập
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Spin>
      </div>
    </>
  );
}
